<app-nav-admin--menu></app-nav-admin--menu>

<div class="configContent">
<h1 class="configTitle">Protection Types</h1>

<table class="table">
  <thead>
    <tr>
      <th class="protectionNumber" scope="col">#</th>
      <th class="protectionType" scope="col">Protection Type</th>
      <th class="protectionDescription" scope="col">Description</th>
      
      <th class="protectionAction" scope="col" >Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let protectionType of protectionTypes; index as i">
      <td class="numberColumn">{{i + 1}}</td>
      <td class="protectionTypeColumn">{{protectionType.name}}</td>
      <td>{{protectionType.descriptionText}}</td>
      <td class="actionColumn">
        <button mat-icon-button (click)="editProtectionType(i)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="deleteProtectionType(i)"><mat-icon>delete</mat-icon></button>
      </td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td class="addProtection">
        <button mat-icon-button (click)="addProtectionType()"><mat-icon>add</mat-icon></button>
      </td>
    </tr>
  </tbody>
</table>

<hr />

<div class="mb-5">
  <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
  <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
</div>
  </div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
